<div [ngStyle]="customStyle()" class="search">
  <div class="search-input">
    <input
      #searchInputElement
      (keyup)="onChange($event)"
      [placeholder]="placeholder()"
      [value]="value()"
      autocomplete="do-not-autofill"
      class="input"
      name="test" />
    <i
      (click)="onReset(searchInputElement)"
      [color]="'WHITE'"
      [iconName]="'CLOSE'"
      [size]="'2rem'"
      class="input-icon"></i>
  </div>
  @if (suggestion()) {
    <div (click)="suggestionClick.emit()" class="search-suggestion">
      <span>{{ suggestion()!.label }}</span>
      @if (suggestion()!.icon) {
        <i [color]="'WHITE'" [iconName]="suggestion()!.icon!" [size]="'2rem'"></i>
      }
    </div>
  }
</div>
